document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    const setMenuOpen = (isOpen) => {
      if (isOpen) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
      menuButton.classList.toggle('is-open', isOpen);
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    };
    menuButton.addEventListener('click', () => setMenuOpen(menu.hasAttribute('hidden')));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hasAttribute('hidden')) {
        setMenuOpen(false);
        menuButton.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!menu.hasAttribute('hidden') && !menu.contains(event.target) && !menuButton.contains(event.target)) setMenuOpen(false);
    });
  }

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('[data-filters]');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => filters.classList.toggle('is-open'));
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const optionInputs = Array.from(section.querySelectorAll('.variant-group input'));
    const variantSelect = section.querySelector('[data-variant-select]');
    const galleryShell = section.querySelector('[data-product-gallery]');
    const gallery = galleryShell?.querySelector('[data-gallery-stage]') || section.querySelector('.product-gallery');
    const preview = section.querySelector('[data-variant-preview]');
    const previewImage = section.querySelector('[data-variant-preview-image]');
    const thumbsHost = galleryShell?.querySelector('[data-gallery-thumbs]');
    const prevButton = galleryShell?.querySelector('[data-gallery-prev]');
    const nextButton = galleryShell?.querySelector('[data-gallery-next]');
    const counter = galleryShell?.querySelector('[data-gallery-counter]');
    const manualMapNodes = Array.from(section.querySelectorAll('[data-option-gallery-map]'));

    if (!variantSelect || !gallery) return;

    const normalize = (value) => (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const cleanUrl = (url) => {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        // Shopify can return the same image at different requested widths.
        // Compare the stable CDN pathname and ignore transformation query params.
        return parsed.pathname
          .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
          .toLowerCase();
      } catch (_) {
        return url.split('?')[0].replace(/^https?:/, '').toLowerCase();
      }
    };

    const allMedia = () => Array.from(gallery.querySelectorAll('[data-product-media]'));
    const removeManualPreviews = () => gallery.querySelectorAll('[data-manual-preview]').forEach((node) => node.remove());
    const manualMappingsForSelection = () => {
      if (!manualMapNodes.length) return [];
      const selected = selectedOptionData();
      const selectedMap = new Map(selected.map((item) => [normalize(item.name), normalize(item.value)]));

      // Letter/model choices must beat broad choices like Color when both are selected.
      // Two-condition mappings (e.g. Model=A + Color=Gold) beat all single-condition mappings.
      const semanticPriority = (name) => {
        const n = normalize(name);
        if (/(^| )(model|modell|letter|buchstabe|initial|char|character)( |$)/.test(n)) return 40;
        if (/(^| )(color|colour|farbe|couleur|colore|cor)( |$)/.test(n)) return 20;
        return 10;
      };

      const candidates = manualMapNodes.map((node) => {
        const name1 = normalize(node.dataset.optionName || '');
        const value1 = normalize(node.dataset.optionValue || '');
        const name2 = normalize(node.dataset.optionName2 || '');
        const value2 = normalize(node.dataset.optionValue2 || '');

        if (!name1 || !value1 || selectedMap.get(name1) !== value1) return null;
        if (name2 || value2) {
          if (!name2 || !value2 || selectedMap.get(name2) !== value2) return null;
        }

        const conditions = name2 && value2 ? 2 : 1;
        const score = (conditions * 100) + semanticPriority(name1) + (name2 ? semanticPriority(name2) : 0);
        const key = `${name1}=${value1}|${name2}=${value2}`;
        return { node, score, key };
      }).filter(Boolean);

      if (!candidates.length) return [];
      const bestScore = Math.max(...candidates.map((item) => item.score));
      const best = candidates.find((item) => item.score === bestScore);
      return candidates
        .filter((item) => item.score === bestScore && item.key === best.key)
        .map((item) => item.node);
    };
    const makeManualPreview = (url, alt) => {
      if (!url) return null;
      const item = document.createElement('div');
      item.className = 'product-gallery__item product-gallery__item--manual-preview';
      item.dataset.manualPreview = '';
      item.dataset.mediaSrc = url;
      const img = document.createElement('img');
      img.src = url;
      img.alt = alt || 'Selected option';
      img.loading = 'eager';
      item.appendChild(img);
      gallery.appendChild(item);
      return item;
    };
    let visibleSlides = [];
    let activeIndex = 0;
    let touchStartX = null;
    let hasUserSelectedOption = false;
    // 2026-10-29: a ?variant= deep link should open on that variant's own image.
    const openedWithVariant = new URL(window.location.href).searchParams.has('variant');

    const slideHeuristicText = (slide) => {
      if (!slide) return '';
      const img = slide.querySelector('img');
      return normalize([
        slide.dataset.mediaAlt || '',
        slide.dataset.mediaSrc || '',
        img?.getAttribute('alt') || '',
        img?.getAttribute('src') || ''
      ].join(' '));
    };

    const preferredStartIndex = (slides) => {
      if (!slides.length) return 0;
      const keywordMatch = slides.findIndex((slide) => /(^| )(model|look|lifestyle|outfit|worn|wearing|on body|person)( |$)/.test(slideHeuristicText(slide)));
      if (keywordMatch >= 0) return keywordMatch;
      return 0;
    };

    const setVisibleSlides = (slides, shouldAnimate = true, activeOverride = null) => {
      visibleSlides = slides.filter(Boolean).filter((slide, index, arr) => arr.indexOf(slide) === index);
      buildThumbs();
      const nextIndex = Number.isInteger(activeOverride) ? activeOverride : preferredStartIndex(visibleSlides);
      activate(nextIndex, shouldAnimate);
    };

    const selectedOptionData = () => {
      const values = [];
      section.querySelectorAll('.variant-group').forEach((group) => {
        const legend = group.querySelector('legend');
        const checked = group.querySelector('input:checked');
        if (checked) values.push({ name: normalize(group.dataset.optionName || legend?.textContent), value: checked.value });
      });
      return values;
    };

    const selectedValues = () => selectedOptionData().map((item) => item.value);

    const selectedColor = () => {
      const named = selectedOptionData().find((item) => /(^| )(color|colour|farbe|couleur|colore|cor)( |$)/.test(item.name));
      return named?.value || '';
    };

    const selectedColorIndex = (color) => {
      const wanted = normalize(color);
      const group = Array.from(section.querySelectorAll('.variant-group')).find((fieldset) => {
        const name = normalize(fieldset.dataset.optionName || fieldset.querySelector('legend')?.textContent);
        return /(^| )(color|colour|farbe|couleur|colore|cor)( |$)/.test(name);
      });
      if (!group) return -1;
      const values = Array.from(group.querySelectorAll('input')).map((input) => normalize(input.value));
      return values.indexOf(wanted);
    };

    // Automatic ordered-image mode:
    // Product image #1 is ALWAYS the storefront/example image.
    // Option value #1 -> product image #2, value #2 -> image #3, etc.
    // For products with several option groups, Letter/Model/Buchstabe/Initial
    // wins over Color so A/B/C can never be overridden by Gold/Silver.
    const selectedOrderedOption = () => {
      const groups = Array.from(section.querySelectorAll('.variant-group'));
      const scoreName = (name) => {
        const n = normalize(name);
        if (/(^| )(model|modell|letter|buchstabe|initial|char|character)( |$)/.test(n)) return 100;
        if (/(^| )(color|colour|farbe|couleur|colore|cor)( |$)/.test(n)) return 50;
        return 0;
      };

      const ranked = groups
        .map((group) => ({ group, name: group.dataset.optionName || group.querySelector('legend')?.textContent || '', score: scoreName(group.dataset.optionName || group.querySelector('legend')?.textContent || '') }))
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score);

      const chosen = ranked[0];
      if (!chosen) return null;
      const inputs = Array.from(chosen.group.querySelectorAll('input'));
      const checked = chosen.group.querySelector('input:checked');
      if (!checked) return null;
      const index = inputs.indexOf(checked);
      if (index < 0) return null;
      return { name: chosen.name, value: checked.value, index, score: chosen.score };
    };

    const orderedMediaForSelection = (media) => {
      const selected = selectedOrderedOption();
      // 2026-10-29: ordered-image mode is only for Letter/Model style options
      // (e.g. LETTER SIGNET CHARM A-Z). Colors use Shopify's variant image mapping.
      if (!selected || selected.score < 100 || !media.length) return null;
      // index + 1 because media[0] is intentionally kept as the preview image.
      return media[selected.index + 1] || null;
    };

    const colorFromAlt = (item) => {
      const raw = item?.dataset.mediaAlt || '';
      const match = raw.match(/(?:\[|\(|^|\s)(?:color|colour|farbe)\s*[:=\-]\s*([^\]\)\|,;]+)/i);
      return match ? normalize(match[1]) : '';
    };

    const mediaMatchesColor = (item, color) => {
      const wanted = normalize(color);
      if (!wanted) return true;
      const explicit = colorFromAlt(item);
      if (explicit) return explicit === wanted;
      const groups = (item.dataset.colorGroup || '').split('||').map(normalize).filter(Boolean);
      if (groups.includes(wanted)) return true;
      const haystack = normalize(`${item.dataset.mediaAlt || ''} ${item.dataset.mediaSrc || ''}`);
      return wanted.length > 1 && (` ${haystack} `).includes(` ${wanted} `);
    };

    const findMediaForVariant = (option) => {
      if (!option) return null;
      const mediaId = option.dataset.mediaId || '';
      if (mediaId) {
        const byId = allMedia().find((item) => item.dataset.mediaId === mediaId);
        if (byId) return byId;
      }
      const targetUrl = cleanUrl(option.dataset.imageUrl || '');
      if (targetUrl) {
        const byUrl = allMedia().find((item) => cleanUrl(item.dataset.mediaSrc || '') === targetUrl);
        if (byUrl) return byUrl;
      }
      return null;
    };

    const sameColorMappedVariant = (color) => {
      const wanted = normalize(color);
      if (!wanted) return null;
      return Array.from(variantSelect.options).find((option) =>
        normalize(option.dataset.colorValue || '') === wanted &&
        (option.dataset.imageUrl || option.dataset.mediaId)
      ) || null;
    };

    const setPreviewFromOption = (option) => {
      if (!preview || !previewImage || !option?.dataset.imageUrl) return null;
      const nextUrl = option.dataset.imageUrl;
      if (previewImage.getAttribute('src') !== nextUrl) previewImage.src = nextUrl;
      previewImage.alt = option.dataset.imageAlt || option.dataset.variantTitle || 'Selected variant';
      preview.dataset.mediaSrc = nextUrl;
      preview.dataset.mediaId = option.dataset.mediaId || '';
      preview.hidden = true;
      return preview;
    };

    const buildThumbs = () => {
      if (!thumbsHost) return;
      thumbsHost.innerHTML = '';
      visibleSlides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (!img?.src) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-gallery__thumb';
        button.dataset.galleryIndex = String(index);
        button.setAttribute('aria-label', `Show product image ${index + 1}`);
        const thumb = document.createElement('img');
        thumb.src = img.currentSrc || img.src;
        thumb.alt = '';
        button.appendChild(thumb);
        button.addEventListener('click', () => activate(index, true));
        thumbsHost.appendChild(button);
      });
    };

    const syncControls = () => {
      const count = visibleSlides.length;
      if (counter) counter.textContent = count > 1 ? `${activeIndex + 1} / ${count}` : '';
      if (prevButton) prevButton.hidden = count <= 1;
      if (nextButton) nextButton.hidden = count <= 1;
      if (thumbsHost) thumbsHost.hidden = count <= 1;
      thumbsHost?.querySelectorAll('[data-gallery-index]').forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === activeIndex);
        if (index === activeIndex) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    const hideEverything = () => {
      allMedia().forEach((item) => {
        item.hidden = true;
        item.classList.remove('is-gallery-active', 'is-variant-primary', 'is-color-hidden');
      });
      if (preview) {
        preview.hidden = true;
        preview.classList.remove('is-gallery-active', 'is-variant-primary');
      }
    };

    const activate = (index, shouldAnimate = true) => {
      if (!visibleSlides.length) return;
      activeIndex = (index + visibleSlides.length) % visibleSlides.length;
      hideEverything();
      const active = visibleSlides[activeIndex];
      active.hidden = false;
      active.classList.add('is-gallery-active');
      if (activeIndex === 0) active.classList.add('is-variant-primary');
      syncControls();
      if (shouldAnimate && !reduceMotion) {
        active.animate?.(
          [{ opacity: .55 }, { opacity: 1 }],
          { duration: 140, easing: 'ease-out' }
        );
      }
    };

    const buildOptionSlides = (match, color) => {
      removeManualPreviews();
      const media = allMedia();
      const wanted = normalize(color);

      // 1) Manual option mapping from Theme Editor ALWAYS wins.
      // Works for Color, Model, Letter, Buchstabe, Initial, etc.
      const manualMaps = manualMappingsForSelection();
      if (manualMaps.length) {
        const manualSlides = [];
        const selected = selectedOptionData();
        const mappedName = normalize(manualMaps[0]?.dataset.optionName || '');
        const mappedSelection = selected.find((item) => normalize(item.name) === mappedName);
        const mappedLabel = mappedSelection?.value || manualMaps[0]?.dataset.optionValue || 'Selected option';

        manualMaps.forEach((map) => {
          let slide = null;
          const imageUrl = map.dataset.imageUrl || '';
          const imageIndex = Math.max(1, Number(map.dataset.imageIndex) || 1) - 1;

          if (imageUrl) {
            const target = cleanUrl(imageUrl);
            slide = media.find((item) => cleanUrl(item.dataset.mediaSrc || '') === target)
              || makeManualPreview(imageUrl, `${mappedLabel} product image`);
          } else if (media[imageIndex]) {
            slide = media[imageIndex];
          }

          if (slide && !manualSlides.includes(slide)) manualSlides.push(slide);
        });

        if (manualSlides.length) {
          setVisibleSlides(manualSlides, true);
          return;
        }
      }

      // 2) Automatic ordered-image mapping. This is intentionally BEFORE Shopify's
      // variant-image mapping because the shop uses image #1 only as the card/example
      // image. Gold/Silver and A/B/C therefore start at product image #2.
      const orderedMedia = orderedMediaForSelection(media);
      if (orderedMedia) {
        // Keep the first Shopify media item as the storefront/model image.
        // On initial page load it stays active; after a shopper changes an option,
        // the selected option image becomes active while the model image remains available.
        const storefrontMedia = media[0] || null;
        const orderedSlides = storefrontMedia && storefrontMedia !== orderedMedia
          ? [storefrontMedia, orderedMedia]
          : [orderedMedia];
        const orderedActive = hasUserSelectedOption && orderedSlides.length > 1 ? 1 : 0;
        setVisibleSlides(orderedSlides, true, orderedActive);
        return;
      }

      // 3) 2026-10-29: Shopify variant images (variant.featured_media).
      // The gallery always shows ALL product images. After a shopper picks a color,
      // images that belong to another color (via variant.featured_media, the images that
      // follow it in the media order, or an alt tag like "[Color: Gold Color]") are hidden,
      // untagged images stay, and the selected variant's own image becomes active.
      let primaryMedia = findMediaForVariant(match);
      if (!primaryMedia && wanted) primaryMedia = findMediaForVariant(sameColorMappedVariant(color));
      const colorTagsOf = (item) => {
        const explicit = colorFromAlt(item);
        if (explicit) return [explicit];
        return (item.dataset.colorGroup || '').split('||').map(normalize).filter(Boolean);
      };
      let slides = media.slice();
      if (hasUserSelectedOption && wanted && media.some((item) => colorTagsOf(item).includes(wanted))) {
        slides = media.filter((item) => {
          const tags = colorTagsOf(item);
          return !tags.length || tags.includes(wanted);
        });
      }
      if (!slides.length) slides = media.slice();
      let activeSlide = 0;
      if ((hasUserSelectedOption || openedWithVariant) && primaryMedia && slides.includes(primaryMedia)) {
        activeSlide = slides.indexOf(primaryMedia);
      }
      setVisibleSlides(slides, true, activeSlide);
    };

    const findMatchingVariant = () => {
      const chosen = selectedValues();
      const options = Array.from(variantSelect.options);
      let match = options.find((option) => {
        const values = (option.dataset.options || '').split('||');
        return values.length === chosen.length && values.every((value, i) => value === chosen[i]);
      });

      if (match) return match;

      // If the current option combination doesn't exist, prefer an available variant
      // with the newly selected color and synchronize the other pills to it.
      const color = normalize(selectedColor());
      if (color) {
        match = options.find((option) => normalize(option.dataset.colorValue || '') === color && !option.disabled)
          || options.find((option) => normalize(option.dataset.colorValue || '') === color);
        if (match) {
          const values = (match.dataset.options || '').split('||');
          section.querySelectorAll('.variant-group').forEach((group, index) => {
            const input = Array.from(group.querySelectorAll('input')).find((radio) => radio.value === values[index]);
            if (input) input.checked = true;
          });
        }
      }
      return match;
    };

    const updateVariant = (match, shouldAnimate = true) => {
      if (!match) return;
      variantSelect.value = match.value;
      const addButton = section.querySelector('[data-add-button]');
      if (addButton) {
        addButton.disabled = match.disabled;
        addButton.textContent = match.disabled ? addButton.dataset.labelUnavailable : addButton.dataset.labelAvailable;
      }
      const priceBox = section.querySelector('[data-product-price]');
      const currentPrice = section.querySelector('[data-product-current-price]');
      const comparePrice = section.querySelector('[data-product-compare-price]');
      if (currentPrice && match.dataset.price) currentPrice.textContent = match.dataset.price;
      if (priceBox) priceBox.classList.toggle('is-sale', match.dataset.onSale === 'true');
      if (comparePrice) {
        const onSale = match.dataset.onSale === 'true' && match.dataset.comparePrice;
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? match.dataset.comparePrice : '';
      }

      const color = match.dataset.colorValue || selectedColor();
      buildOptionSlides(match, color);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    };

    prevButton?.addEventListener('click', () => activate(activeIndex - 1));
    nextButton?.addEventListener('click', () => activate(activeIndex + 1));

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      if (touchStartX === null || visibleSlides.length < 2) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      if (Math.abs(delta) > 42) activate(activeIndex + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    const refreshSelectedVariant = () => {
      const match = findMatchingVariant();
      if (match) updateVariant(match);
      else {
        const addButton = section.querySelector('[data-add-button]');
        if (addButton) { addButton.disabled = true; addButton.textContent = 'UNAVAILABLE'; }
        // Even if Shopify has no exact variant combination, a manual Model/Letter mapping
        // must still switch the gallery immediately.
        buildOptionSlides(variantSelect.options[variantSelect.selectedIndex] || null, selectedColor());
      }
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        hasUserSelectedOption = true;
        refreshSelectedVariant();
      });
      // Some browsers/theme-editor previews update radio state before change fires.
      input.addEventListener('click', () => {
        hasUserSelectedOption = true;
        window.requestAnimationFrame(refreshSelectedVariant);
      });
    });

    section.querySelector('.product-form')?.addEventListener('submit', (event) => {
      if (section.querySelector('[data-add-button]')?.disabled) event.preventDefault();
    });
    updateVariant(variantSelect.options[variantSelect.selectedIndex], false);
  });

  // Hero: the whole drop changes together, including its SHOP THE DROP link.
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-goto]'));
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    let touchStartX = null;
    const autoplay = slider.dataset.autoplay === 'true' && !reduceMotion;
    const interval = Math.max(4000, Number(slider.dataset.interval) || 6000);

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (autoplay && !document.hidden) timer = window.setInterval(() => show(current + 1), interval);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.heroGoto) || 0);
      start();
    }));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
      stop();
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      if (touchStartX !== null) {
        const endX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = endX - touchStartX;
        if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
      }
      touchStartX = null;
      start();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  });

  // Newest drops: swipeable + auto-scroll, no bulky arrow controls.
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const items = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    const dotsHost = carousel.querySelector('[data-carousel-dots]');
    if (!viewport || items.length < 2 || !dotsHost) return;

    let current = 0;
    let maxIndex = 0;
    let timer = null;
    let scrollTimer = null;
    const autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion;
    const interval = Math.max(4000, Number(carousel.dataset.interval) || 5000);

    const stepSize = () => {
      if (items.length < 2) return items[0]?.getBoundingClientRect().width || viewport.clientWidth;
      const a = items[0].getBoundingClientRect();
      const b = items[1].getBoundingClientRect();
      return Math.max(1, b.left - a.left);
    };

    const visibleCount = () => Math.max(1, Math.floor((viewport.clientWidth + 2) / stepSize()));

    const syncDots = () => {
      const dots = Array.from(dotsHost.querySelectorAll('[data-carousel-goto]'));
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };

    const go = (index, behavior = 'smooth') => {
      current = Math.max(0, Math.min(index, maxIndex));
      viewport.scrollTo({ left: current * stepSize(), behavior: reduceMotion ? 'auto' : behavior });
      syncDots();
    };

    const rebuild = () => {
      maxIndex = Math.max(0, items.length - visibleCount());
      current = Math.min(current, maxIndex);
      dotsHost.innerHTML = '';
      for (let i = 0; i <= maxIndex; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-carousel__dot';
        dot.dataset.carouselGoto = String(i);
        dot.setAttribute('aria-label', `Show newest drop ${i + 1}`);
        dot.addEventListener('click', () => {
          go(i);
          start();
        });
        dotsHost.appendChild(dot);
      }
      go(current, 'auto');
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (autoplay && maxIndex > 0 && !document.hidden) {
        timer = window.setInterval(() => go(current >= maxIndex ? 0 : current + 1), interval);
      }
    };

    viewport.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        current = Math.max(0, Math.min(Math.round(viewport.scrollLeft / stepSize()), maxIndex));
        syncDots();
      }, 80);
    }, { passive: true });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    viewport.addEventListener('touchstart', stop, { passive: true });
    viewport.addEventListener('touchend', start, { passive: true });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        rebuild();
        start();
      }, 160);
    });

    rebuild();
    start();
  });
});

// NSC V4.10: desktop product details start collapsed; mobile stays open.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-details]').forEach((details) => {
    const syncProductDetails = () => {
      if (window.matchMedia('(min-width: 991px)').matches) {
        if (!details.dataset.desktopInit) {
          details.removeAttribute('open');
          details.dataset.desktopInit = 'true';
        }
      } else {
        details.setAttribute('open', '');
        delete details.dataset.desktopInit;
      }
    };
    syncProductDetails();
    window.addEventListener('resize', syncProductDetails, { passive: true });
  });

  // Newsletter: validate before submit and show a clear loading state.
  document.querySelectorAll('.newsletter-form').forEach((form) => {
    const email = form.querySelector('input[type="email"]');
    const button = form.querySelector('[data-newsletter-submit]');
    const buttonText = form.querySelector('[data-newsletter-button-text]');
    if (!email || !button) return;

    form.addEventListener('submit', (event) => {
      if (!email.checkValidity()) {
        event.preventDefault();
        email.reportValidity();
        return;
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (buttonText) buttonText.textContent = 'JOINING...';
    });
  });

  const newsletterSuccess = document.querySelector('[data-newsletter-success]');
  if (newsletterSuccess && window.location.hash === '#nsc-newsletter') {
    newsletterSuccess.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

});
